module.exports = __webpack_public_path__ + "static/c5e9e184.fifth-group-img.png";